<template>
  <div class="auth-container">
    <h2>Register</h2>
    <form @submit.prevent="register">
      <div class="form-group">
        <label for="username">Username:</label>
        <input type="text" id="username" v-model="username" required>
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="password" required>
      </div>
      <button type="submit">Register</button>
    </form>
    <p>Sudah punya akun? <router-link to="/login">Login di sini</router-link></p>
    <p v-if="error" class="error-message">{{ error }}</p>
    <p v-if="success" class="success-message">{{ success }}</p>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      username: '',
      password: '',
      error: null,
      success: null,
    };
  },
  methods: {
    async register() {
      try {
        this.error = null;
        this.success = null;
        await axios.post('https://api.pala.linksoftindo.com/api/auth/register', {
          username: this.username,
          password: this.password,
        });
        this.success = 'Pendaftaran berhasil! Silakan login.';
        this.username = '';
        this.password = '';
        // Optionally, redirect to login page after successful registration
        // this.$router.push('/login');
      } catch (err) {
        this.error = err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : 'Terjadi kesalahan saat pendaftaran.';
        console.error('Error register:', err);
      }
    },
  },
};
</script>

<style scoped>
/* Gunakan style yang sama dengan LoginPage.vue */
.auth-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  text-align: center;
}

.auth-container h2 {
  margin-bottom: 25px;
  color: #333;
}

.form-group {
  margin-bottom: 18px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 7px;
  font-weight: bold;
  color: #555;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 16px;
}

button {
  width: 100%;
  padding: 12px;
  background-color: #28a745; /* Warna hijau untuk register */
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 17px;
  font-weight: bold;
  margin-top: 15px;
  transition: background-color 0.2s ease;
}

button:hover {
  background-color: #218838;
}

.error-message {
  color: #dc3545;
  margin-top: 15px;
  font-size: 0.9em;
}

.success-message {
  color: #28a745;
  margin-top: 15px;
  font-size: 0.9em;
}

p {
  margin-top: 20px;
  font-size: 0.9em;
  color: #666;
}

p a {
  color: #28a745; /* Warna hijau untuk link register */
  text-decoration: none;
  font-weight: bold;
}

p a:hover {
  text-decoration: underline;
}
</style>
